<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>朋友圈分享审核列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" lable-positon="right">
        <Row :gutter="32">
          <Col :span="8">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item  label="学生手机号">
            <Input placeholder="支持模糊搜索" name="userMobile"
                   v-model="queryParam.mobile"></Input>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="学生姓名">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.userNickname"></Input>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="状态">
            <Select v-model.number="queryParam.status" placeholder="全部" @on-change="search" clearable>
              <Option v-for="item in $constant.bookCourseChangeStatus"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :span="8">
          <Form-item label="活动类型">
            <Select v-model.number="queryParam.type" placeholder="全部" @on-change="search" clearable>
              <Option value="1" key="1">朋友圈</Option>
              <!-- <Option v-for="item in $constant.activityType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option> -->
            </Select>
          </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="审核人">
              <Input v-model="queryParam.auditorName" placeholder="支持模糊搜索" name="checkAdmin"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="学习导师">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyAdviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="8" >
          <Form-item label="申请时间">
            <Row>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="startTimeDateChange"
                           v-model="queryParam.startTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">-</Col>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="endTimeDateChange"
                           v-model="queryParam.endTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="8">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/activityExamine/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
  </div>

</template>
<script>
  import UserInfoModal from '../crm/UserInfoModal.vue'
  import ShowImageCarousel from '../order/ShowImageCarousel.vue'
  export default {
    components: {
      UserInfoModal, ShowImageCarousel
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        showImgModal: false,
        showImgList: [],
        reload: 0,
        editUser: false,
        uid: null,
        queryParam: {
          uid: '',
          mobile: '',
          userNickname: '',
          adminNickname: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          status: null,
          type: '',
          tchId: null,
          subType: null,
          auditorName: '',
          studyAdviserId: null
        },
        title: [
          {
            title: '学生ID/姓名',
            // width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
            }
          },
          {
            title: '参与凭证',
            align: 'center',
            // width: 110,
            render: (h, params) => {
              let row = params.row
              if (row.pic) {
                return h('a', {on: {click: () => this.viewPic(row)}}, '查看凭证')
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '活动类型',
            align: 'center',
            // width: 100,
            render: (h, params) => {
              let type = params.row.type
              let text = '未知活动'
              if(type == 1){
                text = '朋友圈'
              }
              return h('div', text)
            }
          },
          {
            title: '赠送课时',
            align: 'center',
            // width: 110,
            key: 'activity'
          },
          {
            title: '申请人',
            // width: 110,
            align: 'center',
            key: 'userNickname'
          },
          {
            title: '学导ID/姓名',
            align: 'center',
            // width: 150,
            render: (h, params) => {
              let row = params.row
              return h('span', row.studyAdviserId + '-' + row.studyAdviserName)
            }
          },
          {
            title: '参与时间',
            // width: 170,
            align: 'center',
            key: 'gmtCreate'
          },
          {
            title: '状态',
            align: 'center',
            // width: 100,
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.bookCourseChangeStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '审核人',
            // width: 100,
            align: 'center',
            key: 'auNickname'
          },
          {
            title: '审核时间',
            align: 'center',
            key: 'auditorTime',
            // width: 170
          },
          {
            title: '操作',
            align: 'center',
            // width: 110,
            render: (h, params) => {
              let status = params.row.status
              if (status === 0) {
                return h('div', [
                  h('a', { on: { click: () => { this.onPass(params.row) } } }, '通过'),
                  h('span', {class: 'divider'}),
                  h('a', { on: { click: () => { this.onReject(params.row) } } }, '拒绝')
                ])
              }
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      viewPic (row) {
        this.showImgList = row.urls
        this.showImgModal = true
      },
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/ActivityExamineList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      exportData (type) {
        this.exportLoading = true
        this.$http.get('/bookCourseChange/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '补课时记录.csv'
          link.click()
          this.exportLoading = false
        }).catch((e) => {
          this.exportLoading = false
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onPass (row) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '是否 <b>通过</b> 此次申请？',
          width: 300,
          okText: '确定通过',
          loading: true,
          onOk: () => {
            self.$http.post('/activityExamine/pass', {id: row.id}).then(function (res) {
              self.search()
              self.$Message.success('提交成功!')
              self.$Modal.remove()
            })
          }
        })
      },
      onReject (row) {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '是否 <b>拒绝</b> 此次申请？',
          width: 300,
          okText: '确定拒绝',
          loading: true,
          onOk: () => {
            self.$http.post('/activityExamine/reject', {id: row.id}).then(function (res) {
              self.search()
              self.$Message.success('提交成功!')
              self.$Modal.remove()
            })
          }
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ActivityExamineList.vue?dbe5781e